import { ArrowUpRight } from "lucide-react";
import { Reveal, openRegistration } from "./shared";

export const FinalCta = () => (
  <section
    data-testid="final-cta-section"
    className="bg-gradient-to-b from-indigo-50/60 to-white border-t border-slate-200 py-20 lg:py-24"
  >
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-indigo-700">
          Next session · Thursday · 11:00 UTC
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0b1528] mt-5 leading-tight">
          Stop relying on yesterday's receipt to protect tomorrow's revenue.
        </h2>
        <p className="text-slate-600 text-lg mt-6 max-w-xl mx-auto">
          Reserve your seat for the next live forensic breakdown. Free for Amazon brand founders and operators.
        </p>
        <button
          data-testid="final-cta-btn"
          onClick={openRegistration}
          className="group mt-9 inline-flex items-center gap-2.5 bg-indigo-500 hover:bg-indigo-600 text-white font-bold text-base rounded-full px-10 py-4 transition-colors duration-200 shadow-lg shadow-indigo-200"
        >
          Reserve My Forensic Seat
          <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
        </button>
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-5">
          100% Free · Replay included for registrants
        </p>
      </Reveal>
    </div>
  </section>
);
